/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSupportCaseCommentRequest } from '../models/CreateSupportCaseCommentRequest';
import type { SupportCaseCommentDto } from '../models/SupportCaseCommentDto';
import type { UpdateSupportCaseCommentRequest } from '../models/UpdateSupportCaseCommentRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SupportCaseCommentService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SupportCaseCommentDto OK
     * @throws ApiError
     */
    public updateComment({
        commentId,
        requestBody,
    }: {
        commentId: string,
        requestBody: UpdateSupportCaseCommentRequest,
    }): CancelablePromise<SupportCaseCommentDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/support-case-comments/{commentId}',
            path: {
                'commentId': commentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public deleteComment({
        commentId,
    }: {
        commentId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/support-case-comments/{commentId}',
            path: {
                'commentId': commentId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SupportCaseCommentDto OK
     * @throws ApiError
     */
    public createComment({
        requestBody,
    }: {
        requestBody: CreateSupportCaseCommentRequest,
    }): CancelablePromise<SupportCaseCommentDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/support-case-comments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SupportCaseCommentDto OK
     * @throws ApiError
     */
    public getComments({
        supportCaseId,
    }: {
        supportCaseId: string,
    }): CancelablePromise<Array<SupportCaseCommentDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/support-case-comments/{supportCaseId}',
            path: {
                'supportCaseId': supportCaseId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
